
<tr
  v-tooltip="{ content: sale.title, delay: { show: 1500, hide: 100 }, placement: 'bottom' }"
  :class="['sale-row', { alert: isStaff && sale.alertPrice }]"
  @click.stop.prevent="openSale(sale.url)"
>
  <td>{{ sale.displayDate }}</td>
  <td right>
    <b>{{ $filters.currency(sale.price, { full: true }) }}</b>
  </td>
  <td right>
    {{ sale.listingType }}
  </td>
  <td right>
    {{ sale.platform }}
  </td>

  <td class="action">
    <icon-button
      v-if="sale.notes"
      icon="info"
      size="16"
      :tooltip="sale.notes"
    />

    <icon-button
      v-if="isStaff && isLadderCard"
      icon="delete_outline"
      size="16"
      tooltip="Delete sale"
      @click.stop.prevent="$emit('deleteSale', purgatory ? sale.itemId : sale.id)"
    />
  </td>
</tr>
